import { create } from "zustand";
import { persist } from "zustand/middleware";
import { TPhaseData } from "../types/phase";

interface PhaseStore {
	phase: TPhaseData | null;
	setPhase: (phase: TPhaseData) => void;
}

export const usePhaseStore = create<PhaseStore>()(
	persist(
		(set) => ({
			phase: null,
			setPhase: (phase: TPhaseData) => set({ phase }),
		}),
		{
			name: "phase-store",
		}
	)
);
